import { render } from "./page.vue?vue&type=template&id=60792882&scoped=true"
import script from "./page.vue?vue&type=script&lang=js"
export * from "./page.vue?vue&type=script&lang=js"

import "./page.vue?vue&type=style&index=0&id=60792882&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/FK-YF23001-01-生产-01-综合管理后台sznc_admin-前端构建部署/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60792882"]])

export default __exports__